//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//styles
import { EndCTASection, Title, Copy } from './EndCTA.styles';
import { Container } from '@/components/Grid';

export function EndCTA({ variant = 'top', content }) {
  return (
    <EndCTASection
      id={variant === 'top' ? 'cta' : undefined}
      $variant={variant}
    >
      <Container>
        <Title>
          {content.title}
          <Grad>{content.titleHighlight}</Grad>
        </Title>
        <Copy>{content.copy}</Copy>
        <PillLink
          href={content.ctaHref ?? '/contact/#contact-form'}
          style={{ fontSize: '16px', padding: '16px 32px' }}
          className="qlf-btn-7"
        >
          {content.ctaLabel}
        </PillLink>
      </Container>
    </EndCTASection>
  );
}
